import React, { useState } from 'react';
import styles from './faq.module.scss';
import Accordion from '../../components/Accordion';
import MFaqPage from './mIndex';

const FaqPage = () => {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const handleAccordionClick = (title: string) => {
    if (openAccordion === title) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(title);
    }
  };

  return (
    <section
      className="layoutContainer"
      style={{ backgroundColor: 'var(--color-black)', marginBottom: '-20px' }}
    >
      <div className="layout1000">
        <div className={styles.faq}>
          <div className={styles.faqChild} />
          <div className={styles.faq1}>
            <span>FA</span>
            <i className={styles.q}>Q</i>
          </div>
          <div className={styles.frequentlyAskedQuestions}>
            Frequently asked questions
          </div>

          <div className={styles.faqListWrap}>
            <div className={styles.faqList}>
              <Accordion
                title="What is Hippocrat?"
                isOpen={openAccordion === 'accordion1'}
                onClick={() => handleAccordionClick('accordion1')}
              >
                <p>{`For most of people, blockchain is the notion that is barely known even though the word itself is very popular. It might be because blockchain is a software mainly used by engineer, not by end user. However, installing blockchain software is `}</p>
              </Accordion>
              <Accordion
                title="What can i do with hippocrat?"
                isOpen={openAccordion === 'accordion2'}
                onClick={() => handleAccordionClick('accordion2')}
              >
                <p>
                  Patients
                  <br />
                  - Securely manage your own healthcare data and digital assets
                  collected from varios institutions
                  <br />
                  <br />
                  Medical Institutions
                  <br />
                  - Make proofs of your contributions on generation and
                  cleansing one’s data even after it taken out form your
                  institution
                  <br />
                  <br />
                  Healthcare services
                  <br />- Gain informed consent from data subjects and provide
                  incentives to them so that you can efficiently get and utilize
                  their data
                </p>
              </Accordion>
              <Accordion
                title="When HPO token is needed?"
                isOpen={openAccordion === 'accordion3'}
                onClick={() => handleAccordionClick('accordion3')}
              >
                <p>{`HPO token is utilized as an incentive in Hippocrat ecosystem. It is used as fair and transparent reward for each participant whenever data is stored, managed, and utilized, contributing to the construction of a sustainable ecosystem.`}</p>
              </Accordion>
            </div>
          </div>
          <div className={styles.rectangleDiv}>
            <img alt="" src="/faq/banner.png" />
          </div>
        </div>
      </div>
      <div className="layout800">
        <div className={styles.faq800}>
          <div className={styles.faq} style={{ lineHeight: '42px' }}>
            <span
              style={{
                fontWeight: 'normal',
                fontFamily: 'var(--font-geomanist-ultra)',
              }}
            >
              FA
            </span>
            <i className={styles.q}>Q</i>
          </div>
          <div className={styles.frequentlyAskedQuestions}>
            Frequently asked questions
          </div>
          <img className={styles.maskGroupIcon} alt="" src="/faq/banner.png" />

          <div className={styles.faqListWrap}>
            <div className={styles.faqList}>
              <Accordion
                title="What is Hippocrat?"
                isOpen={openAccordion === 'accordion1'}
                onClick={() => handleAccordionClick('accordion1')}
              >
                <p>{`For most of people, blockchain is the notion that is barely known even though the word itself is very popular. It might be because blockchain is a software mainly used by engineer, not by end user. However, installing blockchain software is `}</p>
              </Accordion>
              <Accordion
                title="What can i do with hippocrat?"
                isOpen={openAccordion === 'accordion2'}
                onClick={() => handleAccordionClick('accordion2')}
              >
                <p>
                  Patients
                  <br />
                  - Securely manage your own healthcare data and digital assets
                  collected from varios institutions
                  <br />
                  <br />
                  Medical Institutions
                  <br />
                  - Make proofs of your contributions on generation and
                  cleansing one’s data even after it taken out form your
                  institution
                  <br />
                  <br />
                  Healthcare services
                  <br />- Gain informed consent from data subjects and provide
                  incentives to them so that you can efficiently get and utilize
                  their data
                </p>
              </Accordion>
              <Accordion
                title="When HPO token is needed?"
                isOpen={openAccordion === 'accordion3'}
                onClick={() => handleAccordionClick('accordion3')}
              >
                <p>{`HPO token is utilized as an incentive in Hippocrat ecosystem. It is used as fair and transparent reward for each participant whenever data is stored, managed, and utilized, contributing to the construction of a sustainable ecosystem.`}</p>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <MFaqPage />
    </section>
  );
};

export default FaqPage;
